import type * as Types from '../../../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStatsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetStatsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly graphStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly cpc: number, readonly currency: string, readonly spent: number, readonly platform: Types.YalperPlatform, readonly extendedPlatform: Types.YalperExtendedPlatform }> } | null } | null };

export type GetUnfinishedMediaplansQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUnfinishedMediaplansQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly unfinishedMediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly startOn: string, readonly endOn?: string | null, readonly type: Types.AccountsMediaplanType, readonly budget: number, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly primary: boolean, readonly name: Types.AccountsKpiName, readonly value: string | number }> | null }> } | null } | null };


export const GetStatsDocument = gql`
    query GetStats($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      graphStats(startDate: $startDate, endDate: $endDate) {
        cpc
        currency
        spent
        platform
        extendedPlatform
      }
    }
  }
}
    `;

/**
 * __useGetStatsQuery__
 *
 * To run a query within a React component, call `useGetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetStatsQuery(baseOptions: Apollo.QueryHookOptions<GetStatsQueryPage, GetStatsQueryVariables> & ({ variables: GetStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatsQueryPage, GetStatsQueryVariables>(GetStatsDocument, options);
      }
export function useGetStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatsQueryPage, GetStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatsQueryPage, GetStatsQueryVariables>(GetStatsDocument, options);
        }
export function useGetStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatsQueryPage, GetStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatsQueryPage, GetStatsQueryVariables>(GetStatsDocument, options);
        }
export type GetStatsQueryHookResult = ReturnType<typeof useGetStatsQuery>;
export type GetStatsLazyQueryHookResult = ReturnType<typeof useGetStatsLazyQuery>;
export type GetStatsSuspenseQueryHookResult = ReturnType<typeof useGetStatsSuspenseQuery>;
export type GetStatsQueryResult = Apollo.QueryResult<GetStatsQueryPage, GetStatsQueryVariables>;
export const GetUnfinishedMediaplansDocument = gql`
    query GetUnfinishedMediaplans {
  currentUser {
    currentCompany {
      unfinishedMediaplans {
        id
        startOn
        endOn
        type
        budget
        kpis {
          primary
          name
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnfinishedMediaplansQuery__
 *
 * To run a query within a React component, call `useGetUnfinishedMediaplansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnfinishedMediaplansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnfinishedMediaplansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnfinishedMediaplansQuery(baseOptions?: Apollo.QueryHookOptions<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>(GetUnfinishedMediaplansDocument, options);
      }
export function useGetUnfinishedMediaplansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>(GetUnfinishedMediaplansDocument, options);
        }
export function useGetUnfinishedMediaplansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>(GetUnfinishedMediaplansDocument, options);
        }
export type GetUnfinishedMediaplansQueryHookResult = ReturnType<typeof useGetUnfinishedMediaplansQuery>;
export type GetUnfinishedMediaplansLazyQueryHookResult = ReturnType<typeof useGetUnfinishedMediaplansLazyQuery>;
export type GetUnfinishedMediaplansSuspenseQueryHookResult = ReturnType<typeof useGetUnfinishedMediaplansSuspenseQuery>;
export type GetUnfinishedMediaplansQueryResult = Apollo.QueryResult<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>;